<template>
    <div>
  
      <p>
<h2> 初始化状态数组,显示创建结果 initSubscribe  ";  </h2>
      </p>
    
  
    </div>
  </template>
  <script>



export default {
    data() {
      return  {   r:{
      }}
      },
created:function(){
  //注意回调函数的作用域!!!
  this.$http.get("/da/init_subscribe").then( (response)=>  {
this.r = response.data

    console.log(response.data)
  })
},

mounted:function(){
  console.log("/da/init_subscribe ==>   完毕")
}

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  